function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 12v8m-5-8h10M16 1c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C1 7.716 7.716 1 16 1zm6 19h3m-3-4h3m-3-4h3",
  stroke: "#9CA6B0",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
function SvgShiftLeaveGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
}
export default SvgShiftLeaveGray;